import { RootState } from 'shared/state';
import { Config } from './types';
import { connect } from 'react-redux';
import LoginButton from './LoginButton';
import { selectUser } from 'shared/state/misc/oidc';
import {
  selectSite,
  selectPages,
  updateCurrentPage,
} from 'shared/state/ducks/sites';
import { applyThemeToPages } from 'shared/state/ducks/sites';

export interface LoginButtonContainerProps {
  siteId: number;
  editing?: boolean;
  isPreview?: boolean;
  widgetState: Widget<Config>;
}

const mapStateToProps = (
  state: RootState,
  ownProps: LoginButtonContainerProps
) => ({
  user: selectUser()(state),
  published: state.published,
  site: selectSite(ownProps.siteId)(state),
  pages: selectPages(ownProps.siteId)(state),
  ...ownProps,
});
const mapDispatchToProps = (
  dispatch: any,
  ownProps: LoginButtonContainerProps
) => ({
  updateCurrentPage: (pageVersion: PageVersion) =>
    dispatch(updateCurrentPage(ownProps.siteId, pageVersion)),
  applyThemeToPages: (
    themeKey: string,
    opts?: { scope?: 'all' | 'current'; persistEnabledKey?: boolean }
  ) => dispatch(applyThemeToPages(ownProps.siteId, themeKey, opts)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginButton);
